import { CrewAccordion } from 'components/elements/crewAccordion/crewAccordion'
import { FC, memo, useCallback } from 'react'
import { useTranslation } from '@crew/modules/i18n'
import { useModal } from 'components/layouts/modal/useModal'
import Add from '~icons/material-symbols/add'
import { ChatStartEntryDialog } from 'features/chat/components/chatStartEntryDialog/chatStartEntryDialog'
import { FavoriteChatList } from './components/favoriteChatList/favoriteChatList'

// お気に入りチャットパネル
export const FavoriteChatPanel: FC = memo(() => {
  const { t } = useTranslation()

  const [isDialogOpen, openDialog, closeDialog] = useModal()

  // チャット開始ダイアログを開くアイコン
  const renderToolIcon = useCallback(() => {
    return <Add width={20} height={20} onClick={openDialog} />
  }, [openDialog])

  return (
    <>
      {/* チャット一覧 */}
      <CrewAccordion
        id="direct-message-user-panel"
        title={t('label.chat')}
        content={<FavoriteChatList />}
        renderToolIcon={renderToolIcon}
      />

      {/* チャット開始ダイアログ */}
      <ChatStartEntryDialog
        title={t('label.chatStart')}
        isOpen={isDialogOpen}
        onClose={closeDialog}
      />
    </>
  )
})
